import { createFileRoute } from "@tanstack/react-router";
import FundManagerNetwork from "@/components/FundManagerNetwork";

function RouteComponent() {
  return <FundManagerNetwork />;
}

export const Route = createFileRoute("/_authenticated/fund-manager-network/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
